import common from './common';
import config from '@/config/config';

let money = value => {
  return '￥' + value.toFixed(2);
};

let toFixed = (value, numberData) => {
  if (typeof value === 'number' && !isNaN(value)) {
    var number = numberData || 2;
    return parseFloat(value.toFixed(number));
  } else if (isNaN(value)) {
    return 0;
  } else {
    return value;
  }
};

let number = num => {
  if (num > 0) {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  } else {
    return num;
  }
};
let distance = value => {
  if (typeof value === 'number') {
    return value.toFixed(1) + 'km';
  } else {
    return '-- km';
  }
};
let formatMinute = (value, type) => {
  // 默认是分钟, type  m  是秒
  if (type === 'm') {
    if (value > 60) {
      let hour;
      let minute = parseInt(value / 60);
      let second = value % 60;

      if (minute > 60) {
        hour = parseInt(minute / 60);
        minute = minute % 60;
        return hour + '小时' + minute + '分钟' + second + '秒';
      } else {
        return minute + '分钟' + second + '秒';
      }
    } else {
      return value + '秒';
    }
  } else if (type === 'minute') {
    let minute = parseInt(value / 60);
    return minute + '分钟';
  } else {
    if (value > 60) {
      let hour = parseInt(value / 60);
      let minute = value % 60;
      return hour + '小时' + minute + '分钟';
    } else if (value > 0) {
      return value + '分钟';
    } else {
      return '0分钟';
    }
  }
};
let formatTime = (value) => {

  if (value) {
    if(typeof value == 'number'){
      if (value > 0) {
        let second = value * 60;
        var timestamp = Date.parse(new Date()) / 1000;
        let time = (timestamp + second) * 1000;
        let timeStr = common.thisTimes('HH:MM',new Date(time));
        return timeStr

        // let minute = value;

        // if (minute > 60) {
        //   let hour = parseInt(minute / 60);
        //   minute = minute % 60;
        //   return timeZero(hour) + ':' + timeZero(minute);
        // } else {
        //   return '00:'+ timeZero(minute);
        // }
      } else {
        return common.thisTimes('HH:MM');
      }
    }else{
      return common.thisTimes('HH:MM');
    }
  }else{
    return common.thisTimes('HH:MM');
  }
}
// let timeZero = (value)=>{
//   if(value < 10){
//     return '0'+ value
//   }else{
//     return value
//   }
// }

let time = (value, typeStr) => {
  if (value) {
    var type = typeStr || 'yyyy-MM-dd HH:MM:SS';
    var date = Date.parse(value);
    if (!isNaN(date)) {
      return common.thisTimes(type, new Date(date));
    } else {
      return value;
    }
  } else {
    return '';
  }
};

let defaultNumber = (value, defaultText) => {
  if (value >= 0 || value < 0) {
    return value;
  } else {
    return defaultText || defaultText === '' ? defaultText : 0;
  }
};

let pile = (value) => {
  if (value >= 0) {
    let str = parseFloat(value);
    let num = config.pileFixed >= 0 ? config.pileFixed : 3;
    return str.toFixed(num);
  } else if (isNaN(value)) {
    return '';
  } else {
    return 0;
  }
};
let phoneLastFour = (value, number) => {
  if (value) {
    let num = number || 4;
    let val = value + '';
    return val.slice(val.length - num, val.length);
  } else {
    return '';
  }
};
let formatNullValue = (value) => {
  return (typeof (value) === 'undefined') || value == null || value === '' ? '-' : value;
};
let formatNumber = (value, decimal) => {
  if (typeof (value) === 'number') {
    return value.toFixed(decimal);
  }else if(typeof (value) === 'string'){
    return Number(value).toFixed(decimal)
  }
  return value;
};
let formatDate = (value) => {
  if (value) {
    return value.getFullYear() + '-' + addZero(value.getMonth() + 1) + '-' + addZero(value.getDate());
  }
  return null;
};
function addZero(num) {
  return num > 9 ? num : '0' + num;
}
let getFilePath = (value) => {
  if (value && value.indexOf('http') == 0) {
    return value
  } else if(value && typeof (value) !== 'undefined' ) {
    return config.fileUrl + value;
  }
  return '';
};
let formatCity = (value) => {
  if (value === '选择城市') {
    return value;
  }
  if (!value) {
    return '-';
  }else {
    return value.replace('市', '');
  }
};
let formatTwoValue = (value1, value2) => {
  return formatNullValue(value1) + formatNullValue(value2);
};
let formatElecUnit = (value1) => {
  return formatNullValue(value1) + '度';
};
let formatMoneyUnit = (value1) => {
  return formatNullValue(value1) + '元';
};
/**
 * 获取格式化订单状态的描述
 * 退款中 3, 5
 * 已拒绝 7
 * 已退回 6
 * 退款失败 8
 */
let formatOrderStatusDesc = (value) => {
  if (value.orderType == '2') {//如果是退款记录则要特殊处理
    if (value.orderStatus == 3 || value.orderStatus == 5) {
      return '退款中'
    } else if (value.orderStatus == 7) {
      return '已拒绝'
    } else if (value.orderStatus == 6) {
      return '已退回'
    } else if (value.orderStatus == 8) {
      return '退款失败'
    } else {
      return value.orderStatusDesc;
    }
  }else {
    return value.orderStatusDesc;
  }
};

let getGunNumberDesc = (value) =>{
  if (!value && value != 0) {
    return '-';
  }
  if (value == 3 || value == 1) {
    return 'A';
  }
  if (value == 2 || value == 0) {
    return 'B';
  }
};
let timeStr = (value,type) =>{
  if(value){
    if(type == 'date'){
      let arr = value.split(' ');
      return arr[0].replace(/\-/g, '.');// eslint-disable-line
    }else{
      return value.replace(/\-/g, '.');// eslint-disable-line
    }
    
  }else{
    return ''
  }
}
let getNumberTwo = (number) =>{
  if (number >= 0) {
    return number.toFixed(2);
  }else{
    return '--'
  }
}
let getNumber = (number,num) =>{
  if (number >= 0) {
    num = num || 2
    return parseFloat(number.toFixed(num));
  }else{
    return '--'
  }
}
export {
  money,
  toFixed,
  number,
  distance,
  formatMinute,
  time,
  defaultNumber,
  pile,
  phoneLastFour,
  formatNullValue,
  formatTwoValue,
  formatDate,
  getFilePath,
  formatCity,
  formatElecUnit,
  formatMoneyUnit,
  formatNumber,
  formatOrderStatusDesc,
  getGunNumberDesc,
  timeStr,
  formatTime,
  getNumberTwo,
  getNumber
};
